import { trackClientEvent } from '../../../../trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'faire_direct-credit_hc_article_fd_landing_page-view';

/**
 * Open https:&#x2F;&#x2F;www.faire.com&#x2F;support&#x2F;articles&#x2F;360034300092 from the FD Landing Page top area under Start Shopping.
 */
export function trackFaireDirectCreditHcArticleFdLandingPageView(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
  });
}
